import { useEffect, useState } from "react"

import { ChevronUpIcon } from "@/domains/icons/huge-icons/monotone/chevron-up"

export const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button whenever user has scrolled at all
      setIsVisible(window.scrollY > 0)
    }

    // Check initial scroll position
    toggleVisibility()

    window.addEventListener("scroll", toggleVisibility)

    return () => {
      window.removeEventListener("scroll", toggleVisibility)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  if (!isVisible) {
    return null
  }

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-p400-light bg-p400 text-t100 shadow-lg transition-all hover:bg-p400-light focus:outline-none focus:ring-2 focus:ring-p100 focus:ring-offset-2 focus:ring-offset-p500"
      aria-label="Back to top"
    >
      <ChevronUpIcon className="h-5 w-5" />
    </button>
  )
}
